import styled, {css} from 'styled-components';
import {device} from 'styled/device';

type ButtonProps = {
  hasError?: boolean;
  disabled?: boolean;
};

export const Container = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 20px;
  width: 100%;
  max-width: 150px;
  height: 100%;
  position: relative;
`;

export const ButtonStepper = styled.button<ButtonProps>`
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid ${props => (props.hasError ? '#f84b7a' : '#393abd')};
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: #393abd;
    transition: fill 0.2s;

    @media (max-width: ${device.tablet}) {
      width: 27px;
      height: 27px;
    }
  }

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
`;

export const Number = styled.span<ButtonProps>`
  flex-grow: 1;
  text-align: center;
  font-weight: 600;
  font-size: inherit;
  color: ${props => (props.hasError ? '#f84b7a' : '#161643')};
  user-select: none;

  ${({disabled}) =>
    disabled &&
    css`
      opacity: 0.7;
    `}
`;
